import React from 'react'

import { Formik } from 'formik'

import { AdminContext } from 'contexts/AdminContext'

import { Button, Col, Form, Row } from '_zari/core'
import Yup from '_zari/validation/_yup'

import { ModalidadCalculosDeDepreciacionConstant } from 'constants/index'

import { IdGen, KeyEventUtil } from 'utils'

import * as FormGroups from './formGroups'

const ValidationSchema = Yup.object().shape({
  porcentajeParticipacion: Yup.number().min(0).max(100).required()
})

const DetallesCabeceraSection = ({ dispatch }) => {
  const __adminContext = React.useContext(AdminContext)

  const formInitialValues = React.useMemo(() => {
    return {
      __keyRow: IdGen.newId(),
      _idCentroCostoNivel1: '',
      _idCentroCostoNivel2: '',
      centroCostoNivel1Info: '',
      centroCostoNivel2Info: '',
      cuentaContableDebe: '',
      cuentaContableDebeInfo: '',
      cuentaContableHaber: '',
      cuentaContableHaberInfo: '',
      porcentajeParticipacion: ''
    }
  }, [])

  const onSubmit = React.useCallback(
    (formData, { resetForm }) => {
      dispatch({
        type: 'agregar',
        payload: { ...formData, porcentajeParticipacion: parseFloat(formData.porcentajeParticipacion) }
      })
      resetForm({
        values: {
          ...formInitialValues,
          __keyRow: IdGen.newId()
        },
        isSubmitting: false
      })

      KeyEventUtil.leaveOnKeyEvent('select-centroCosto')
    },
    [dispatch, formInitialValues]
  )

  return (
    <Formik initialValues={formInitialValues} onSubmit={onSubmit} validationSchema={ValidationSchema}>
      {({ errors, handleSubmit, isSubmitting, setFieldValue, handleChange, touched, values }) => (
        <Form>
          <Row key={values.__keyRow}>
            {(__adminContext.modalidadCalculoDeDepreciacion === ModalidadCalculosDeDepreciacionConstant._CLASE9_CC || __adminContext.modalidadCalculoDeDepreciacion === ModalidadCalculosDeDepreciacionConstant.CLASE9) && (
              <>
                <Col md={2}>
                  <FormGroups.CentroCostoNivel1FormGroup
                    iError={errors._idCentroCostoNivel1}
                    iTouched={touched._idCentroCostoNivel1}
                    fIsSubmitting={isSubmitting}
                    handleChange={handleChange}
                    setFieldValue={setFieldValue}
                  />
                </Col>
                {values._idCentroCostoNivel1 && (
                  <Col md={2}>
                    <FormGroups.CentroCostoNivel2FormGroup
                      iError={errors._idCentroCostoNivel2}
                      iTouched={touched._idCentroCostoNivel2}
                      setFieldValue={setFieldValue}
                      iValue={values.centroCostoNivel2Info}
                      idNodoPadre={values._idCentroCostoNivel1}
                    />
                  </Col>
                )}
              </>
            )}
            <Col md={2}>
              <FormGroups.CuentaContableDebeFormGroup
                iError={errors.cuentaContableDebe}
                iTouched={touched.cuentaContableDebe}
                iValue={values.cuentaContableDebeInfo}
                setFieldValue={setFieldValue}
              />
            </Col>
            <Col md={2}>
              <FormGroups.CuentaContableHaberFormGroup
                iError={errors.cuentaContableHaber}
                iTouched={touched.cuentaContableHaber}
                iValue={values.cuentaContableHaberInfo}
                setFieldValue={setFieldValue}
              />
            </Col>
            <Col md={2}>
              <FormGroups.PorcentajeParticipacionFormGroup
                iError={errors.porcentajeParticipacion}
                iTouched={touched.porcentajeParticipacion}
                fIsSubmitting={isSubmitting}
              />
            </Col>
            <Col md={2}>
              <Form.Group>
                <Form.Label text='&ensp;' md={12} />
                <Col md={12}>
                  <Button id='activofijo-button-nuevodetalle' block onClick={handleSubmit}>
                    Agregar
                  </Button>
                </Col>
              </Form.Group>
            </Col>
          </Row>
        </Form>
      )}
    </Formik>
  )
}

export default React.memo(DetallesCabeceraSection)
